import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";

import styles from "./style.module.scss";

const dynamicImageImport = (path) => {
  return import(/* @vite-ignore */ `${path}`)
    .then((module) => module.default)
    .catch((err) => {
      console.error("Failed to load image:", err);
      return null;
    });
};

const DynamicImageComponent = (props) => {
  const { src, ...newProps } = props;
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    dynamicImageImport(src).then((src) => {
      setImageSrc(src);
    });
  }, [src]);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={imageSrc} {...newProps} />;
};

class Results57 extends Component {
  // Renders the result section (predicted or actual)
  renderResultsSection = (label, results, sectionType) => {
    return (
      <div className={styles[`results__${sectionType}`]}>
        <h4>
          <FormattedMessage id={label} defaultMessage={label} description="" />
        </h4>
        <div className={styles[`results__${sectionType}__result`]}>
          {this.renderResultImages(results, sectionType)}
        </div>
      </div>
    );
  };

  // Renders the images for the result section
  renderResultImages = (results, sectionType) => {
    return ["experimental", "control"].map((key) => (
      <div key={key}>
        <DynamicImageComponent
          src={`./img/p-${key === "experimental" ? "plus" : "minus"}-${
            results[key] || "0"
          }.svg`}
          draggable={false}
          alt={this.props.intl.formatMessage({
            id: this.props.aria[`p${key === "experimental" ? "+" : "-"}`][
              results[key] || 0
            ],
            defaultMessage:
              this.props.aria[`p${key === "experimental" ? "+" : "-"}`][
                results[key] || 0
              ],
            description: "",
          })}
        />
        {this.renderResultSpan(results[key], sectionType, key)}
      </div>
    ));
  };

  // Renders the correct/incorrect label
  renderResultSpan = (result, sectionType, key) => {
    const isCorrect =
      (sectionType === "predicted" && key === "experimental" && result === 4) ||
      (sectionType === "actual" && key === "control" && result === 2);

    return (
      <span className={styles[isCorrect ? "correct" : "incorrect"]}>
        {isCorrect
          ? this.props.intl.formatMessage({
              id: this.props.component_strings.correct,
              defaultMessage: this.props.component_strings.correct,
              description: "",
            })
          : this.props.intl.formatMessage({
              id: this.props.component_strings.incorrect,
              defaultMessage: this.props.component_strings.incorrect,
              description: "",
            })}
      </span>
    );
  };

  render() {
    const { predictions, actual } = this.props;

    return (
      <div className={styles.results}>
        {this.renderResultsSection(
          this.props.component_strings.label1,
          predictions,
          "predicted"
        )}
        {this.renderResultsSection(
          this.props.component_strings.label2,
          actual,
          "actual"
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    predictions: state.transformingBacteria.predictions,
    actual: state.transformingBacteria.actual,
  };
};

export const TransformingBacteriaResults = connect(mapStateToProps)(
  injectIntl(Results57)
);
